module.exports = __webpack_public_path__ + "static/media/eastern.2e14d819.png";